/** The website's Firebase web config, shared by the browser's form writes
 *  (`firebase.ts`) and the build's job read (`data/loadJobs.ts`). No
 *  projectId means Firebase is not configured (a plain local `next dev`). */
export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FB_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FB_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FB_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FB_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FB_APP_ID
};

/** The named Firestore database the website reads and writes. */
export const WEBSITE_DATABASE = "website";
